import { useEffect, useState } from 'react'
import { subscribeHelplyUnread } from 'util/helplyWidget'
import useHelplyWidgetEnabled from './useHelplyWidgetEnabled'

/** The custom support icon reads the widget's own unread state. */
const useHelplyUnread = () => {
  const { widget } = useHelplyWidgetEnabled()
  const [hasUnread, setHasUnread] = useState(false)
  useEffect(
    () => {
      setHasUnread(false)
      if (!widget) return undefined
      return subscribeHelplyUnread(setHasUnread)
    },
    [widget]
  )
  return widget && hasUnread
}

export default useHelplyUnread
